export enum PrintPreviewTargetGroup {
    SWISS = 'swiss',
    GERMAN = 'german',
}
